const MANAGEMENT_OBSERVATION_COLUMNS = {
  handling_number: "Identificação",
  tag_id: "Identificação Eletrônica",
  sisbov: "SISBOV",
  gender: "Sexo",
  breed_name: "Raça",
  lot_name: "Lote",
  last_weight_date: "Data do Último Peso",
  last_weight: "Última Pesagem",
  last_observation_date: "Data da Última Observação",
  last_observation: "Última Observação",
};

export default MANAGEMENT_OBSERVATION_COLUMNS;
